import { useQuery } from '@tanstack/react-query'
import { aiStudioService } from '../../../service/aiStudio'

function useGetVideoQuota() {
  return useQuery({
    queryKey: ['get-video-quota'],
    queryFn: () => aiStudioService.getVideoQuota(),
    staleTime: 0, // 항상 stale로 처리
    gcTime: 0, // 캐시 시간 0으로 설정
    refetchOnMount: true, // 마운트될 때마다 refetch
    refetchOnWindowFocus: false,
    retry: false,
  })
}

export default useGetVideoQuota